import React, { useState } from "react";
import { db } from "./firebase";
import { doc, updateDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./MillionaireGame.css";

const MillionaireLiveJoin = () => {
  const [name, setName] = useState("");
  const [gameCode, setGameCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleJoin = async () => {
    setError("");
    if (!name || !gameCode) {
      setError("Please enter both your name and the game code.");
      return;
    }

    const gameRef = doc(db, "liveGames", gameCode);

    try {
      const snap = await getDoc(gameRef);
      if (!snap.exists()) {
        setError("Game not found. Please check the code.");
        return;
      }

      const gameData = snap.data();
      if (!gameData.isActive) {
        setError("This game is no longer active.");
        return;
      }

      const playerId = name.toLowerCase().replace(/\s+/g, "") + "_" + Date.now();

      await updateDoc(gameRef, {
        [`players.${playerId}`]: {
          name,
          answer: "",
          score: 0,
          joinedAt: serverTimestamp(),
          usedLifelines: {
            fiftyFifty: false,
            askAudience: false,
            phoneFriend: false,
          },
        },
      });

      navigate(`/millionaire-live-game/${gameCode}?playerId=${playerId}`);
    } catch (err) {
      console.error("Join error:", err);
      setError("Something went wrong. Try again.");
    }
  };

  return (
    <div className="welcome-screen">


      <div
        style={{
          background: "rgba(255,255,255,0.1)",
          padding: "2rem",
          borderRadius: "12px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 0 15px rgba(0,0,0,0.2)",
          color: "white",
        }}
      >
        <h2 style={{ marginBottom: "1rem" }}>Join a Game</h2>

        <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{
            width: "100%",
            padding: "0.75rem",
            marginBottom: "1rem",
            borderRadius: "8px",
            border: "none",
            fontSize: "1rem",
          }}
        />

        <input
        type="text"
          placeholder="Game Code"
          value={gameCode}
          onChange={(e) => setGameCode(e.target.value.toUpperCase())}
          style={{
            width: "100%",
            padding: "0.75rem",
            marginBottom: "1.5rem",
            borderRadius: "8px",
            border: "none",
            fontSize: "1rem",
          }}
        />

        {error && (
          <p style={{ color: "#ff7675", marginBottom: "1rem", fontWeight: "bold" }}>
            ⚠ {error}
          </p>
        )}

        <button className="start-btn" onClick={handleJoin}>
          Join Game
        </button>
      </div>
    </div>
  );
};

export default MillionaireLiveJoin;
